/** Ruta de consola hacia el mensaje de chat que originó una reserva. */
export function bookingChatPath(conversationId: string, messageId?: string | null): string {
  const base = `/app/conversations/${conversationId}`;
  if (!messageId) return base;
  return `${base}?mensaje=${encodeURIComponent(messageId)}`;
}
